$(function(){
  if ($('.banner-publicitaire').length > 0) {
    var apiUrlStats = '/api/v1/banners/stats';

    var banner_img = $('.banner-publicitaire').find('img'),
    banner_id = banner_img.data('id'),
    banner_key = banner_img.data('key'),
    client_id = $('.login-btn.logged-in').data('id');

    client_id = client_id == undefined ? 0 : client_id;

    if (readCookie(banner_key + 'view') == null) {
      triggerBannerEvent(1, banner_key + 'view-v2');
    }

    if (readCookie(banner_key + 'click') == null) {
      $('.banner-publicitaire').on('click', function(e){
        e.preventDefault();

        var that = $(this),
        url = that.attr('href');

        triggerBannerEvent(2, banner_key + 'click-v2');
        
        window.open(url);
      });
    }

    function triggerBannerEvent(action, key) {
      $.ajax({
        url: apiUrlStats,
        type: 'PUT',
        dataType: 'json',
        data: {
          client_id: client_id,
          action: action,
          banner_id: banner_id,
          banner_key: banner_key
        },
      })
      .done(function(data) {
        if (parseInt(data) == 1) {
          var tomorrow = moment().add(1, 'day').startOf('day'),
          seconds = tomorrow.diff(moment(), 'seconds');

          createCookie(key, 1, seconds);
        }
      });
    }
  }
});